﻿import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/components/paginator/paginator';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@NgModule({
    imports: [RouterModule, CommonModule, PaginatorModule],
    declarations: [HeaderComponent, SidebarComponent],
    exports: [HeaderComponent, SidebarComponent]
})
export class SharedModule {

}